import { Col, Row } from "react-bootstrap";
import { Block } from "../../../hoc/Block";
import { InputField } from "../../../components/controls/InputField/InputField";
import React from "react";
import styles from "../NewChecklist.module.css";

export const FinalScore = (props) => {
  return (
      <div>
        <p className="text-start fw-bold mt-3 mb-0">
          Final score (Data coverage and accuracy)
        </p>
        <div className="hr"></div>
        <Block className="p-1">
          <Row>
            <Col xs={5} className="d-flex justify-content-between">
              <label className="fst-italic">Coverage index weight (%):</label>
              <InputField
                  type="number"
                  id="coverage"
                  name="coverage"
                  fieldtype="number"
              />

            </Col>
            <Col xs={7} className="d-flex justify-content-around">
              <label className="fst-italic">Accuracy index of data (%):</label>
              <InputField
                  type="number"
                  id="accuracy"
                  name="accuracy"
                  fieldtype="number"
              />
            </Col>
          </Row>
        </Block>
      </div>
  );
};
